module.exports = {
	baseURL: "/",
	baseRoute: "/*",
	version: "e8f0748",
	host: "https://chemnet.berkeley.edu/chemnet",
	reactHost: "https://chemnet.berkeley.edu",
}
